import axios from 'axios';

const axiosRequest = () => {
  axios.defaults.baseURL = 'https://billing.ritm.uz/api/v1/';
  return axios;
};

export default axiosRequest;
